package com.arena_web.pages

import androidx.compose.runtime.Composable
import com.arena_web.ui.layouts.PageLayout
import com.arena_web.ui.sections.info.InfoBullet
import com.arena_web.ui.sections.info.InfoPageScaffold
import com.arena_web.ui.sections.info.InfoParagraph
import com.arena_web.ui.sections.info.InfoSection
import com.varabyte.kobweb.core.Page

@Page("/terms")
@Composable
fun TermsPage() {
    PageLayout(
        title = "Terms of Service",
        description = "Terms of Service for Arena Pro Play.",
        mobileReady = true,
    ) {
        InfoPageScaffold(title = "Terms of Service") {
            InfoSection("1. Acceptance of terms") {
                InfoParagraph(
                    "By creating an account or using Arena Pro Play (\"Arena\", \"we\", \"us\"), you agree to these " +
                        "Terms of Service. If you do not agree, please do not use the service."
                )
            }
            InfoSection("2. The service") {
                InfoParagraph(
                    "Arena is a platform that helps people discover, create, and join sports events, connect with " +
                        "other players, and communicate around games. We may add, change, or remove features at any " +
                        "time as the service evolves."
                )
            }
            InfoSection("3. Your account") {
                InfoBullet("You must provide accurate information when registering and keep your credentials secure.")
                InfoBullet("You are responsible for all activity that happens under your account.")
                InfoBullet("You must be legally able to enter into this agreement in your jurisdiction to use Arena.")
            }
            InfoSection("4. User conduct") {
                InfoParagraph("When using Arena you agree not to:")
                InfoBullet("Harass, threaten, or discriminate against other users.")
                InfoBullet("Post content that is unlawful, misleading, or infringes the rights of others.")
                InfoBullet("Use the service for spam, fraud, or any unauthorised commercial activity.")
                InfoBullet("Attempt to disrupt, reverse-engineer, or gain unauthorised access to the service.")
            }
            InfoSection("5. Events and physical activity") {
                InfoParagraph(
                    "Arena helps you find and organise sports events, but we do not run the events themselves. " +
                        "Participation in any physical activity is at your own risk. Assess your own fitness and the " +
                        "conditions of any venue before playing, and treat other participants with respect."
                )
            }
            InfoSection("6. Content") {
                InfoParagraph(
                    "You keep ownership of the content you post on Arena. By posting, you grant us a non-exclusive " +
                        "licence to host and display that content as part of operating the service. We may remove " +
                        "content that violates these terms."
                )
            }
            InfoSection("7. Purchases and Arena Coins") {
                InfoParagraph(
                    "Arena offers optional packs of Arena Coins — digital content spent inside the service on " +
                        "features such as AI-generated player card avatars and Pro events. Coins are not money: " +
                        "they have no value outside Arena and cannot be cashed out, transferred between users, " +
                        "traded, or exchanged."
                )
                InfoBullet("Current pack prices are listed on our Pricing page and at checkout.")
                InfoBullet("Coins are credited to your account immediately after a successful payment.")
                InfoBullet(
                    "Refunds and cancellations are governed by our Refund Policy, available in the footer of this " +
                        "site."
                )
                InfoBullet(
                    "Payments are processed by our payment partners; purchases in the mobile apps are handled by " +
                        "the Apple App Store or Google Play under their own terms."
                )
            }
            InfoSection("8. Termination") {
                InfoParagraph(
                    "You can stop using Arena and delete your account at any time. We may suspend or terminate " +
                        "accounts that violate these terms or harm the community."
                )
            }
            InfoSection("9. Disclaimers and liability") {
                InfoParagraph(
                    "The service is provided \"as is\" without warranties of any kind. To the maximum extent " +
                        "permitted by law, Arena is not liable for indirect or consequential damages, or for events, " +
                        "venues, or interactions between users."
                )
            }
            InfoSection("10. Changes to these terms") {
                InfoParagraph(
                    "We may update these terms from time to time. If changes are material, we will notify you " +
                        "through the service. Continuing to use Arena after changes take effect means you accept the " +
                        "updated terms."
                )
            }
            InfoSection("11. Contact") {
                InfoParagraph(
                    "If you have questions about these terms, contact us through the Supports link in the footer."
                )
            }
        }
    }
}
